module.exports = new __parcel__URL__("card_apache.fa051759.png").toString();